module.exports = __webpack_public_path__ + "img/sad-emoji.e9bec3ef.svg";